/**
 * Handle full page drag and drop of files.
 *
 * Depends on:
 *   - mixins/fullPageDragAndDrop.scoped.css
 *
 * Usage:
 *   - Add a div with a matching id
 *   - It must have style="visibility: hidden; opacity: 0; position: fixed"
 *   - Implement onFilesChosen(files) hook method.
 *   - Call installFullPageDragAndDropEventHandlers() on startup
 */

const ID = '#drag-and-drop-area';

const fullPageDragAndDrop = {
  data() {
    return {
      fullPageDragAndDropEventHandlers: null,
    };
  },
  methods: {
    installFullPageDragAndDropEventHandlers() {
      this.uninstallFullPageDragAndDropEventHandlers();

      const vm = this;

      function getArea() {
        return document.querySelector(ID);
      }

      function onDragEnter(e) {
        const area = getArea();
        area.style.visibility = '';
        area.style.opacity = 1;
      }

      function onDragLeave(e) {
        e.preventDefault();
        const area = getArea();
        area.style.visibility = 'hidden';
        area.style.opacity = 0;
      }

      function onDragOver(e) {
        e.preventDefault();
        const area = getArea();
        area.style.visibility = '';
        area.style.opacity = 1;
      }

      function onDrop(e) {
        e.preventDefault();
        const area = getArea();
        area.style.visibility = 'hidden';
        area.style.opacity = 0;

        const files = e.dataTransfer.files;
        vm.onFilesChosen(files);
      }

      this.fullPageDragAndDropEventHandlers = {};
      this.fullPageDragAndDropEventHandlers.dragenter = onDragEnter;
      this.fullPageDragAndDropEventHandlers.dragleave = onDragLeave;
      this.fullPageDragAndDropEventHandlers.dragover = onDragOver;
      this.fullPageDragAndDropEventHandlers.drop = onDrop;

      window.addEventListener('dragenter', onDragEnter);
      window.addEventListener('dragleave', onDragLeave);
      window.addEventListener('dragover', onDragOver);
      window.addEventListener('drop', onDrop);
    },
    uninstallFullPageDragAndDropEventHandlers() {
      if (!this.fullPageDragAndDropEventHandlers) {
        return;
      }

      window.removeEventListener(
        'dragenter',
        this.fullPageDragAndDropEventHandlers.dragenter
      );
      window.removeEventListener(
        'dragleave',
        this.fullPageDragAndDropEventHandlers.dragleave
      );
      window.removeEventListener(
        'dragover',
        this.fullPageDragAndDropEventHandlers.dragover
      );
      window.removeEventListener(
        'drop',
        this.fullPageDragAndDropEventHandlers.drop
      );

      this.fullPageDragAndDropEventHandlers = {};
    },
  },
};

export default fullPageDragAndDrop;



// WEBPACK FOOTER //
// ./src/mixins/fullPageDragAndDrop.js